
(function() {
  if (window.location.pathname.indexOf('/products/') === -1) return;
  
  var handle = window.location.pathname.split('/products/')[1];
  if (!handle) return;
  handle = handle.split('?')[0].split('#')[0];
  
  var tagMap = {
    'organic': '\ud83c\udf31 Organic',
    'gluten-free': '\ud83c\udf3e Gluten-Free',
    'keto': '\ud83e\udd51 Keto-Friendly',
    'vegan': '\ud83c\udf3f Vegan',
    'non-gmo': '\u2705 Non-GMO',
    'high-protein': '\ud83d\udcaa High Protein',
    'zero-sugar': '0g Sugar',
    'paleo': '\ud83e\uddac Paleo',
    'non-alcoholic': '\ud83c\udf7b Non-Alcoholic',
    'gut-health': '\ud83e\udda0 Gut Health',
    'prebiotic': '\ud83e\udda0 Prebiotic',
    'cold-pressed': '\ud83e\uddf4 Cold-Pressed'
  };

  var brandStories = {
    'OLIPOP': 'A new kind of soda. OLIPOP combines prebiotics, plant fiber, and botanicals to support digestive health\u2014without the sugar.',
    'Siete': 'Born from a family\u2019s journey with autoimmune conditions, Siete makes grain-free Mexican-American foods everyone can enjoy.',
    'Athletic Brewing Co.': 'The craft beer you love, without the alcohol. Athletic Brewing is the #1 non-alcoholic craft brewery in America.',
    'Chomps': 'Whole30-approved, grass-fed beef sticks made with clean ingredients. No sugar, no fillers, just real meat.',
    'Celsius': 'Clinically proven to accelerate metabolism. Celsius is the better-for-you energy drink.',
    "Rao's": 'Slow-simmered Italian sauce made with only the finest ingredients, from the Rao\u2019s restaurant legacy in NYC.',
    'Carbone': 'Restaurant-quality Italian at home. Carbone brings fine dining flavors from their legendary NYC restaurant to your pantry.',
    'Poppi': 'Prebiotic soda that\u2019s actually good for your gut. Made with apple cider vinegar and real fruit juice.',
    'Kodiak Cakes': 'Fueling adventures since 1982. Kodiak makes whole grain, protein-packed foods that taste incredible.',
    'GOODLES': 'Mac and cheese, upgraded. GOODLES packs protein, fiber, and 21 nutrients into your favorite comfort food.',
    'LesserEvil': 'Organic, mindfully made snacks. LesserEvil proves that popcorn and puffs can be both clean and crave-worthy.',
    'Ghost': 'Born from a passion for the community, Ghost makes bold-flavored, fully transparent sports nutrition products.',
    'Fever-Tree': 'If 3/4 of your drink is the mixer, mix with the best. Fever-Tree uses the finest natural ingredients from around the world.',
    'Botanic Tonics': 'Plant-powered feel-good tonics made with kava and other ancient botanicals for a natural mood lift.',
    'Good Culture': 'Cottage cheese, reinvented. Good Culture uses organic, pasture-raised milk and simple ingredients.',
    'Archer': 'Better-for-you jerky made with 100% grass-fed beef. Zero sugar, high protein, and impossibly tender.',
    'So Good So You': 'Cold-pressed juice shots packed with functional ingredients to boost immunity and energy\u2014organically.',
    'Ready': 'Clean protein bars that taste like dessert. Ready uses simple, whole-food ingredients with no compromises.'
  };

  function init() {
    fetch('/products/' + handle + '.json')
      .then(function(r) { return r.json(); })
      .then(function(d) {
        var vendor = d.product.vendor || '';
        var rawTags = d.product.tags || '';
        var tags = rawTags.split(', ').map(function(t) { return t.trim().toLowerCase(); });
        
        var target = document.querySelector('.product-information, .product-description');
        if (!target) {
          var f = document.querySelector('form[action*="/cart/add"]');
          if (f) target = f.parentElement;
        }
        if (!target) return;

        // Trust signal — below add-to-cart
        var buyBtn = document.querySelector('.product-form__cart-submit, form[action*="/cart/add"] button[type="submit"]');
        if (buyBtn) {
          var trustEl = document.createElement('div');
          trustEl.className = 'shoplift-pdp-trust';
          trustEl.innerHTML = '<span>Free delivery on every order</span><span>No minimum. No membership.</span>';
          buyBtn.parentElement.insertBefore(trustEl, buyBtn.nextSibling);
        }

        // Badges
        var badges = [];
        tags.forEach(function(t) { if (tagMap[t]) badges.push(tagMap[t]); });
        if (badges.length > 0) {
          var bc = document.createElement('div');
          bc.className = 'shoplift-product-badges';
          bc.innerHTML = badges.map(function(b) { return '<span class="product-badge">' + b + '</span>'; }).join('');
          target.appendChild(bc);
        }

        // Brand story
        if (vendor && brandStories[vendor]) {
          var bs = document.createElement('div');
          bs.className = 'shoplift-brand-story';
          bs.innerHTML = '<div class="brand-story-header"><span class="brand-story-label">About ' + vendor + '</span></div><p class="brand-story-text">' + brandStories[vendor] + '</p>';
          target.appendChild(bs);
        }
      })
      .catch(function(e) { console.log('Shoplift PDP:', e); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
